import React from 'react';
import ContactInfo from './ContactInfo';
import FooterBrand from './FooterBrand';
import FooterLinks from './FooterLinks';
import SocialMedia from './SocialMedia';

/**
 * Desktop Footer Component
 * Displays footer content optimized for desktop screens
 * 
 * @param {Object} data - Footer data object
 * @param {Boolean} isDarkMode - Dark mode state
 * @param {String} className - Additional CSS classes
 */
const DesktopFooter = ({ data, isDarkMode, className = '' }) => {
    if (!data) return null;

    return (
        <footer className={`d-none d-md-block ${className}`} style={{
            backgroundColor: isDarkMode ? '#1a1a1a' : '#16110d',
            transition: 'background-color 0.3s ease',
            borderTop: `1px solid ${isDarkMode ? '#333' : '#444'}`
        }}>
            <div className="tw-container py-5">
                <div className="row g-4">
                    {/* Company Info Section */}
                    <div className="col-lg-4 col-md-6">
                        <FooterBrand 
                            footerIcon={data.footerIcon}
                            description={data.FooterDescription}
                            isDarkMode={isDarkMode}
                        />
                        
                        <ContactInfo 
                            addresses={data.Address}
                            isDarkMode={isDarkMode}
                        />
                    </div>

                    {/* Services Links */}
                    {data.LeftBottomLinks && data.LeftBottomLinks.filter(link => !link.isHidden).length > 0 && (
                        <div className="col-lg-2 col-md-6">
                            <FooterLinks links={data.LeftBottomLinks} />
                        </div>
                    )}

                    {/* Legal Links */}
                    {data.rightBottomLinks && data.rightBottomLinks.filter(link => !link.isHidden).length > 0 && (
                        <div className="col-lg-2 col-md-6">
                            <FooterLinks links={data.rightBottomLinks} />
                        </div>
                    )}

                    {/* Social Media Section */}
                    {data.socialIcons && data.socialIcons.length > 0 && (
                        <div className="col-lg-4 col-md-6">
                            <SocialMedia 
                                socialIcons={data.socialIcons}
                                isDarkMode={isDarkMode}
                            />
                        </div>
                    )}
                </div>
                
                {/* Footer Bottom */}
                <div style={{
                    borderTop: `1px solid ${isDarkMode ? '#333' : '#444'}`,
                    marginTop: '0.5rem',
                    paddingTop: '2rem'
                }}>
                    <div className="d-flex justify-content-center">
                        <p style={{
                            color: '#888',
                            fontSize: '14px',
                            margin: '0',
                            textAlign: 'center'
                        }}>
                            {data.Copyrights || `© ${new Date().getFullYear()} HireGo. All Rights Reserved.`}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default DesktopFooter;
